import Vue from "vue"

let $tools = {};



$tools.levelTexts = ["黑铁",
  "黄铜",
  "白银",
  "黄金",
  "铂金",
  "钻石",
  "大师",
  "宗师",
  "最强王者"];

$tools.productRegions = ["美国", "英国", "法国", "德国", "加拿大", "南非", "新加坡", "印度", "澳洲", "东盟", "拉美", "东南亚", "非洲"];

$tools.countrys = [
  {id: "ASIA", name: "亚洲"
      ,children: [{id: "CN", name: "中国"}, {id: "JP", name: "日本"}, {id: "", name: "韩国"}, {id: "AF", name: "阿富汗"}]
  },
  {id: "EUROPE", name: "欧洲"
      ,children: [
        {id: "GB", name: "英国"}, 
        {id: "FR", name: "法国"}, 
        {id: "DE", name: "德国"}, 
        {id: "NL", name: "荷兰"}, 
        {id: "ES", name: "西班牙"}, 
        {id: "AT", name: "奥地利"}, 
        {id: "RU", name: "俄罗斯"}, 
        {id: "BY", name: "白俄罗斯"},
        {id: "UA", name: "乌克兰"},
        {id: "CZ", name: "捷克"},
        {id: "RO", name: "罗马尼亚"},
        {id: "HU", name: "匈牙利"},
        {id: "PT", name: "葡萄牙"},
        {id: "PL", name: "波兰"},
        {id: "CH", name: "瑞士"},
        {id: "AT", name: "奥地利"},
        {id: "GR", name: "希腊"},
        {id: "ES", name: "西班牙"},
        {id: "SK", name: "斯洛伐克"},
        {id: "FI", name: "芬兰"},
        {id: "IT", name: "意大利"},
        {id: "BE", name: "比利时"},
        {id: "MT", name: "马耳他"},
        {id: "LT", name: "立陶宛"},
        {id: "SE", name: "瑞典"},
        {id: "NO", name: "挪威"},
        {id: "HR", name: "克罗地亚"},
        {id: "IE", name: "爱尔兰"},
        {id: "NL", name: "荷兰"},
        {id: "LU", name: "卢森堡"},
        {id: "DK", name: "丹麦"}
      ]
  },
  {id: "AMERICA", name: "美洲"
      ,children: [{id: "US", name: "美国"}, {id: "CA", name: "加拿大"}, {id: "AR", name: "阿根廷"}]
  },
  {id: "OCEANIA", name: "大洋洲"
      ,children: [{id: "AU", name: "澳大利亚"}, {id: "NZ", name: "新西兰"}]
  },
  {id: "AFRICA", name: "非洲"
      ,children: [{id: "ZA", name: "南非"}, {id: "", name: ""}]
  },
]

$tools.countryCache = null;
$tools.countryName = function(id) {
  if ($tools.countryCache == null) {
    let data = {};

    for (var i in $tools.countrys) {
      if ($tools.countrys[i].children != null) {
        let cs = $tools.countrys[i].children;

        for (var j in cs) {
          data[cs[j].id] = cs[j].name;
        }
      }
    }

    $tools.countryCache = data
  }

  if ($tools.countryCache != null && $tools.countryCache[id] != null) {
    return $tools.countryCache[id]
  }
}

$tools.levelTag = function (grade) { // 等级名称
  grade = grade ? parseInt(grade / 100) : 0;
  grade = grade >= $tools.levelTexts.length ? $tools.levelTexts.length - 1 : grade;
  return this.levelTexts[grade];
}

$tools.splitToInt = function(data, splitor) {
  if (data && splitor) {
    var result = [];

    for (var i in data.split(splitor)) {
      result.push(window.parseInt(data.split(splitor)[i]))
    }

    return result;
  } else {
    return [];
  }
}


$tools.mainHeight = function () { // 获取主区域高度
  let clienHeight = document.documentElement.clienHeight || document.body.clientHeight;
  return clienHeight - 60
}


$tools.timestampToTime = function (timestamp) { // 获取时间戳
  return timestamp ? this.dateToTime(new Date(timestamp)) : timestamp;
}

$tools.timestampToDay = function (timestamp) { // 获取时间戳
  return timestamp ? this.dateToDay(new Date(timestamp)) : timestamp;
}

$tools.timestampToMonth = function (timestamp) { // 获取时间戳
  return timestamp ? this.dateToMonth(new Date(timestamp)) : timestamp;
}

$tools.dateToTime = function (date) { // 获取时间戳
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

$tools.dateToDay = function (date) { // 获取时间戳
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d;
}

$tools.dateToMonth = function (date) { // 获取时间戳
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM;
}

$tools.fileSize = function (value) {
  if (null == value || value == '') {
    return "0 Bytes";
  }
  var unitArr = new Array("B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
  var index = 0;
  var srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);
  size = size.toFixed(2);//保留的小数位数
  return size + unitArr[index];
}


$tools.parsecost = function(cost, format) {
  cost = cost ? cost : 0;
  cost =  window.parseFloat(window.parseFloat(cost / 100).toFixed(2));
  return format ? this.formatcost(cost) : cost
}

$tools.formatcost = function (value) { // 金额 格式化
  if (!value && value !== 0) return '-';
  var intPart = Number(value) | 0; //获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

  var floatPart = ".00"; //预定义小数部分
  var value2Array = value.toString().split(".");

  //=2表示数据有小数位
  if (value2Array.length == 2) {
      floatPart = value2Array[1].toString(); //拿到小数部分

      if (floatPart.length == 1) { //补0,实际上用不着
          return intPartFormat + "." + floatPart + '0';
      } else {
          return intPartFormat + "." + floatPart;
      }
  } else {
      return intPartFormat + floatPart;
  }
}

Vue.prototype.$tools = $tools;